import { AvailableCountries } from 'types/users.types';
import type { CountryAlpha3Code } from 'types/countries';

/**
 * Maps Accountable signup user country (alpha-2) to ISO 3166-1 alpha-3
 * in uppercase form expected by accountable-banking onboarding APIs (e.g. DEU, BEL).
 */
export function userCountryToOnboardingAlpha3(
  country: AvailableCountries | undefined,
): CountryAlpha3Code {
  switch (country) {
    case AvailableCountries.belgium:
      return 'BEL';
    case AvailableCountries.germany:
      return 'DEU';
    default:
      return 'BEL';
  }
}

/**
 * Normalizes alpha-3 from the residency select (e.g. "ind", " IND ") to
 * uppercase API enum values ("IND").
 */
export function normalizeAddressCountryAlpha3(
  code: CountryAlpha3Code | undefined,
): CountryAlpha3Code | null {
  if (code == null) return null;
  return code.trim().toUpperCase() as CountryAlpha3Code;
}
